// Utility functions to build items array & product IDs
function buildItems(eData) {
  return (eData.items || []).map(item => ({
    id: String(item.id),
    name: item.name,
    variant: String(item.variant),
    brand: item.brand || "",        // adjust if brand is available
    category: item.category || "",  // adjust if category is available
    price: item.price,
    quantity: item.quantity
  }));
}

function buildProdIds(eData) {
  const prefix = "shopify_IN";  // adjust country code if needed (IN for India)
  return (eData.items || []).map(item => {
    return `${prefix}_${item.id}_${item.variant}`;
  });
}

// Existing / old event functions

function breezePurchase(evt) {
  try {
    merchantPurchaseCustomCode(evt.data);
  } catch (err) {
    console.error('Error in breezePurchase:', err);
  }
}

function merchantPurchaseCustomCode(e) {
  // Old logic (gtag & dataLayer)
//   function t() { dataLayer.push(arguments); }
//   window.dataLayer = window.dataLayer || [];
//   t("js", new Date());
//   t("config", "AW-16532085024");

//   window.gtag("event", "purchase", {
//     send_to: ["AW-16532085024/aV3lCM-xyLkZEKCyjss9"],
//     value: e.totalPrice,
//     currency: "INR",
//     transaction_id: e.shopOrderId
//   });

  // New event via Shopify.analytics.publish

  const items = buildItems(e);
  const ecomm_prodid = buildProdIds(e);

  const eventData = {
    event_category: "ecommerce",
    currency: e.currency,
    value: e.totalPrice,
    transaction_id: e.shopOrderId || "",
    ecomm_prodid: ecomm_prodid,
    items: items,
    phone_num: e.userDetails?.phone || "",
    email: e.userDetails?.email || "",
    city: e.userDetails?.city || "",
    state: e.userDetails?.state || "",
    pincode: e.userDetails?.postalCode || "",
    first_name: e.userDetails?.name || "",
    last_name: ""  // or parse name if you have first/last split
  };

  console.log("🔔 Shopify custom event firing: PurchaseSR", eventData);
  Shopify.analytics.publish('Purchase_breeze', eventData);
}

function breezeInitiateCheckout(evt) {
  console.log("Triggered breezeInitiateCheckout with detail:", evt.detail);
  try {
    merchantInitiateCheckoutCustomCode(evt.data);
  } catch (err) {
    console.error('Error in breezeInitiateCheckout:', err);
  }
}

function merchantInitiateCheckoutCustomCode(e) {
  // Old logic
//   window.gtag("js", new Date());
//   window.gtag("config", "AW-16532085024");
//   window.gtag("event", "begin_checkout", {
//     send_to: ["AW-16532085024/-PElCL26yLkZEKCyjss9"],
//     value: e.totalPrice,
//     currency: "INR",
//     transaction_id: e.shopOrderId
//   });

  // New event via Shopify.analytics.publish
  const items = buildItems(e);
  const ecomm_prodid = buildProdIds(e);

  const eventData = {
    event_category: "ecommerce",
    currency: e.currency,
    value: e.totalPrice,
    transaction_id: e.shopOrderId || "",
    ecomm_prodid: ecomm_prodid,
    items: items,
    phone_num: e.userDetails?.phone || "",
    email: e.userDetails?.email || "",
    city: e.userDetails?.city || "",
    state: e.userDetails?.state || "",
    pincode: e.userDetails?.postalCode || "",
    first_name: e.userDetails?.name || "",
    last_name: ""
  };

  console.log("🔔 Shopify custom event firing: Initiate_CheckoutSR", eventData);
  Shopify.analytics.publish('Initiate_Checkout_breeze', eventData);
}

// New custom events: Shipping Info, Payment Info

function breezeAddShippingInfo(evt) {
  console.log("Triggered breezeAddShippingInfo with detail:", evt.detail);
  try {
    merchantAddShippingInfoCustomCode(evt.data);
  } catch (err) {
    console.error('Error in breezeAddShippingInfo:', err);
  }
}

function merchantAddShippingInfoCustomCode(e) {
  const items = buildItems(e);
  const ecomm_prodid = buildProdIds(e);

  const eventData = {
    event_category: "ecommerce",
    currency: e.currency,
    value: e.totalPrice,
    transaction_id: e.shopOrderId || "",
    ecomm_prodid: ecomm_prodid,
    items: items,
    phone_num: e.userDetails?.phone || "",
    email: e.userDetails?.email || "",
    city: e.userDetails?.city || "",
    state: e.userDetails?.state || "",
    pincode: e.userDetails?.postalCode || "",
    first_name: e.userDetails?.name || "",
    last_name: ""
  };

  console.log("🔔 Shopify custom event firing: Add_ShippingInfoSR", eventData);
  // Example inside your function

Shopify.analytics.publish('Add_ShippingInfo_breeze', eventData)
  .then((result) => {
    // result might be true/false depending on success
    console.log("✅ Add_ShippingInfoSR published successfully:", result, eventData);
  })
  .catch((error) => {
    console.error("❌ Add_ShippingInfoSR publish failed:", error, eventData);
  });

}

function breezeAddPaymentInfo(evt) {
  console.log("Triggered breezeAddPaymentInfo with detail:", evt.detail);
  try {
    merchantAddPaymentInfoCustomCode(evt.data);
  } catch (err) {
    console.error('Error in breezeAddPaymentInfo:', err);
  }
}

function merchantAddPaymentInfoCustomCode(e) {
  const items = buildItems(e);
  const ecomm_prodid = buildProdIds(e);

  const eventData = {
    event_category: "ecommerce",
    currency: e.currency,
    value: e.totalPrice,
    transaction_id: e.shopOrderId || "",
    ecomm_prodid: ecomm_prodid,
    items: items,
    phone_num: e.userDetails?.phone || "",
    email: e.userDetails?.email || "",
    city: e.userDetails?.city || "",
    state: e.userDetails?.state || "",
    pincode: e.userDetails?.postalCode || "",
    first_name: e.userDetails?.name || "",
    last_name: ""
  };

  console.log("🔔 Shopify custom event firing: Add_PaymentInfoSR", eventData);
  Shopify.analytics.publish('Add_PaymentInfo_breeze', eventData);
}

// Event listeners

window.addEventListener("breeze-purchase", evt => {
  breezePurchase(evt.detail);
});

window.addEventListener("breeze-initiate-checkout", evt => {
  breezeInitiateCheckout(evt.detail);
});

// Ensure these custom events are emitted somewhere in your system
window.addEventListener("breeze-add-shipping-info", evt => {
  breezeAddShippingInfo(evt.detail);
});

window.addEventListener("breeze-add-payment-info", evt => {
  breezeAddPaymentInfo(evt.detail);
});
